var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('span',{staticClass:"d-block text-no-nowrap caption",attrs:{"data-cy":"net-amount"}},[_vm._v("\n    "+_vm._s(_vm.$t('net_amount'))+":\n    "+_vm._s(_vm._f("price")(_vm.amount))+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }